import { Component, Output, ViewChild, EventEmitter, AfterViewChecked, Input, OnChanges } from '@angular/core';
import { AbTestsService } from "../../ab-tests/services/ab-tests.service";
import * as moment from 'moment'
import { AbTestVariant } from "../../ab-tests/ab-tests.interfaces";
const alertify = require("alertify.js");

declare var jQuery: any;

@Component({
  selector: 'ch-ab-tests-modal-dialog',
  templateUrl: './ab-tests-modal-dialog.component.html',
  styleUrls: ['./ab-tests-modal-dialog.component.css'],
})
export class AbTestsModalDialogComponent implements OnChanges, AfterViewChecked {
  @Input() public show: boolean;
  @Input() public memberId: string;
  @Output() public onClose: EventEmitter<any> = new EventEmitter();
  @ViewChild('modal') private modal;
  private change: boolean;

  public loading = false;
  public abTestVariants: AbTestVariant[];

  constructor(private abTestService: AbTestsService) { }

  ngOnInit() {
    alertify.logPosition("bottom right");
    this.getAbTests();
  }

  ngOnChanges() {
    if (this.show) {
      this.change = true;
    }
  }

  ngAfterViewChecked() {
    if (this.change) {
      jQuery(this.modal.nativeElement)
        .modal({
          backdrop: false,
        })
        .on('hidden.bs.modal', e => {
          this.onClose.emit(e);
        });

      this.change = false;
    }
  }

  private getAbTests() {
    this.loading = true;
    this.abTestService.getAbTestForUser(this.memberId).subscribe(
      resp => {
        this.loading = false;
        this.abTestVariants = resp.json();
      },
      error => {
        this.loading = false;
        this.alertError(error);
      }
    );
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`
      );
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/ab-tests-modal-dialog/ab-tests-modal-dialog.component.ts